import { render, staticRenderFns } from "./RestarauntPage.vue?vue&type=template&id=3d91c2c4&scoped=true&lang=html&"
import script from "./RestarauntPage.vue?vue&type=script&lang=js&"
export * from "./RestarauntPage.vue?vue&type=script&lang=js&"
import style0 from "./RestarauntPage.vue?vue&type=style&index=0&id=3d91c2c4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91c2c4",
  null
  
)

export default component.exports